import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {StorageService} from './storage.service';
import {DataService} from "./data.service";

@Injectable({
    providedIn: 'root',
})
export class WebsocketService {
    private socket: WebSocket;
    private isConnected: boolean = false; // Track connection state
    private connectionSubject = new Subject<boolean>(); // Observable for connection state
    public messages: Subject<any> = new Subject<any>(); // Observable for incoming messages
    private userId: string | null = null; // Store the authenticated user ID

    constructor(private dataService: DataService) {
       this.establishConnection();
    }

    establishConnection(){
        const self = StorageService.getItem('self');
        if (self) {
            this.socket = new WebSocket('ws://localhost:2345');

            this.socket.onopen = () => {
                console.log('WebSocket connection established');
                this.isConnected = true;
                this.connectionSubject.next(true); // Notify subscribers that the connection is open
            };

            this.socket.onmessage = (event) => {
                const message = JSON.parse(event.data); // Parse incoming messages as JSON
                // this.messages.next(message); // Emit the message to subscribers
                this.dataService.sendMessage(message);
                // console.log('msg from socket ', message);
            };

            this.socket.onclose = () => {
                console.log('WebSocket connection closed');
                this.isConnected = false;
                this.connectionSubject.next(false); // Notify subscribers that the connection is closed
            };

            this.socket.onerror = (error) => {
                console.error('WebSocket error:', error);
                this.isConnected = false;
                this.connectionSubject.next(false); // Notify subscribers of the error
            };
        }
    }

    /**
     * Wait for the WebSocket connection to open before sending messages.
     */
    private waitForConnection(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.isConnected) {
                resolve();
            } else {
                const subscription = this.connectionSubject.subscribe((connected) => {
                    if (connected) {
                        subscription.unsubscribe(); // Clean up the subscription
                        resolve();
                    }
                });
            }
        });
    }

    /**
     * Authenticate the user with the backend WebSocket server.
     * @param userId - The unique ID of the user.
     */
    async authenticate(userId: string) {
        this.userId = userId;
        await this.waitForConnection(); // Wait for the connection to open
        const authMessage = {
            type: 'auth',
            user_id: userId,
            device: 'DESKTOP'
        };
        this.socket.send(JSON.stringify(authMessage)); // Send authentication message
        console.log('Authentication message sent:', authMessage);
    }

    /**
     * Send a private message to another user.
     * @param toUserId - The ID of the user to send the message to.
     * @param content - The content of the message.
     */
    async sendPrivateMessage(toUserId: string, content: any) {
        if (!this.userId) {
            console.error('User is not authenticated.');
            return;
        }

        await this.waitForConnection(); // Wait for the connection to open
        const privateMessage = {
            type: content.type,
            to_user_id: toUserId,
            content: content,
            device: 'DESKTOP'
        };
        this.socket.send(JSON.stringify(privateMessage)); // Send private message
        // console.log('Private message sent ' , privateMessage);
    }

    /**
     * Close the WebSocket connection.
     */
    closeConnection() {
        this.socket.close();
        console.log('WebSocket connection closed.');
    }
}
